<template>
    <div class="pt-4 w-full">
        <slot />
    </div>
</template>
